export default __webpack_public_path__ + "static/media/short-arrow.8c6f339d.svg";